export const UNIT = [
  // { name: 'minutos', value: 1 }, // TODO - Remove comment when the task schedule runs between 1 - 5 minutes
  { name: 'hora', value: 60 },
  { name: 'dias', value: 1440 },
  { name: 'semanas', value: 10080 },
  { name: 'meses', value: 43800 }
]

export const MAP_KEY_EVENT = {
  relative_before: 'before',
  relative_moment: 'moment',
  relative_after: 'after'
}

export const OPTIONS_RELATIVE = [
  {
    id: 'service_order.scheduling',
    name: 'agendamento',
    value: 'scheduling',
    entity: 'service_order'
  },
  {
    id: 'service_order.current_status_date',
    name: 'data do status atual',
    value: 'current_status_date',
    entity: 'service_order'
  }
]
